import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BasketProvider } from './components/BasketContext';
import { AuthProvider } from './components/AuthContext';
import { PricingProvider } from './components/PricingContext';
import { ServiceCatalogProvider } from './components/ServiceCatalogContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import AccountDetails from './components/AccountDetails';
import Contact from './components/Contact';
import SicknessLetters from './components/SicknessLetters';
import TravelAndHolidayLetters from './components/TravelAndHolidayLetters';
import VisaMedicalCertificates from './components/VisaMedicalCertificates';
import GeneralReferrals from './components/GeneralReferrals';
import RecoveryCertificates from './components/RecoveryCertificates';
import Login from './components/Login';
import VerifyLogin from './components/VerifyLogin';
import Account from './components/Account';
import VerificationPage from './components/VerificationPage';
import PaymentSuccess from './components/PaymentSuccess';
import Basket from './components/Basket';
import Faq from './components/Faq';
import Reviews from './components/Reviews';
import Checkout from './components/Checkout';
import CodeOfPractice from './components/CodeOfPractice';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import CookiePolicy from './components/CookiePolicy';
import Questionnaire from './components/Questionnaire';
import EmergencyInfo from './components/EmergencyInfo';
import LoginPage from './components/LoginPage'; // Import the LoginPage
import './App.css';

/**
 * A component that wraps the main application logic, including routing.
 * This is the "unlocked" view of your website.
 */
const MainApp = () => (
    <AuthProvider>
        <ServiceCatalogProvider>
        <PricingProvider>
        <BasketProvider>
            <Router>
                <div className="App">
                    <Header />
                    <main className="main-content">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/account/details" element={<AccountDetails />} />
                            <Route path="/reviews" element={<Reviews />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/basket" element={<Basket />} />
                            <Route path="/faq" element={<Faq />} />
                            <Route path="/code-of-practice" element={<CodeOfPractice />} />
                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                            <Route path="/cookie-policy" element={<CookiePolicy />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/payment-success" element={<PaymentSuccess />} />
                            <Route path="/services/sickness-letters" element={<SicknessLetters />} />
                            <Route path="/services/travel-holiday-letters" element={<TravelAndHolidayLetters />} />
                            <Route path="/services/visa-medical-certificates" element={<VisaMedicalCertificates />} />
                            <Route path="/services/general-referrals" element={<GeneralReferrals />} />
                            <Route path="/services/recovery-certificates" element={<RecoveryCertificates />} />

                            {/* Auth Routes */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/verify-login" element={<VerifyLogin />} />
                            <Route path="/verify/:verificationId" element={<VerificationPage />} />
                            <Route path="/account" element={<Account />} />
                            <Route path="/questionnaire/:productId" element={<Questionnaire />} />
                            <Route path="/emergency-info" element={<EmergencyInfo />} />
                        </Routes>
                    </main>
                    <Footer />
                    <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} />
                </div>
            </Router>
        </BasketProvider>
        </PricingProvider>
        </ServiceCatalogProvider>
    </AuthProvider>
);

/**
 * The root component that decides whether to show the LoginPage or the MainApp.
 */
const App = () => {
    // Check sessionStorage for the authentication flag
    const [isAuthenticated, setIsAuthenticated] = useState(
        () => sessionStorage.getItem('isAuthenticated') === 'true'
    );

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    // If not authenticated, show the login page.
    if (!isAuthenticated) {
        return <LoginPage onLogin={handleLogin} />;
    }

    // If authenticated, show the main application.
    return <MainApp />;
};

export default App;